// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"265":"Index","450":"About","982":"Price"}[chunkId] + "." + {"265":"98a5fa42","450":"46deec85","982":"170c12a3"}[chunkId] + ".chunk.css";
};